import { render, staticRenderFns } from "./ProductBookmarkCard.vue?vue&type=template&id=125c15a8&scoped=true&"
import script from "./ProductBookmarkCard.vue?vue&type=script&lang=js&"
export * from "./ProductBookmarkCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductBookmarkCard.vue?vue&type=style&index=0&id=125c15a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125c15a8",
  null
  
)

export default component.exports